import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { UserContactStatus } from 'node_js/models/enums/user-contact-status';
import { UserContact } from 'node_js/models/tables/user_contact';
import { connLink, getCurrentDateForDB, presentSnackBar } from 'src/global';
import { UserAuthService } from './user-auth.service';
import { HttpClient } from '@angular/common/http';
import { UserContactRequest } from 'node_js/models/tables/user_contact_request';
import { FailedResponse } from 'node_js/models/failed-response.model';
import { SnackBarColor } from 'node_js/models/enums/snackbar-color';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserNotification } from 'node_js/models/tables/user_notification';
import { UserNotificationType } from 'node_js/models/enums/user-notification-type';
import { LanguageService } from './language.service';
import { UserNotificationContactRequest } from 'node_js/models/business/user_notification_settings/user-notification-contact-request';
import { UserNotificationLabRequest } from 'node_js/models/business/user_notification_settings/user-notification-lab-request';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService {

  constructor(private http:HttpClient, private matSnackBar:MatSnackBar, private languageService:LanguageService) {
  }

  async setupUserNotificationLocally(userNotification:UserNotification){
    let translatedLocalMessage = "user-notification-message."
    console.log("user notification",userNotification)
    if (userNotification.notificationType == UserNotificationType.CONTACTREQUEST || userNotification.notificationType == UserNotificationType.CONTACTREQUESTACCEPTED){
      translatedLocalMessage += userNotification.notificationType;
      let userNotificationContactRequest:UserNotificationContactRequest = userNotification.dynamicSettings;
      translatedLocalMessage = await this.languageService.getTranslationWithParams(translatedLocalMessage,[userNotificationContactRequest.nickname],true);
    }
    else if (userNotification.notificationType == UserNotificationType.LABUSERREQUEST){
      translatedLocalMessage += userNotification.notificationType;
      let userNotificationLabRequest:UserNotificationLabRequest = userNotification.dynamicSettings;
      translatedLocalMessage = await this.languageService.getTranslationWithParams(translatedLocalMessage,[userNotificationLabRequest.nickname,userNotificationLabRequest.labName],true);

    }
    userNotification.translatedLocalMessage = translatedLocalMessage
  }
  

  viewedNotifications(userAuthService:UserAuthService){
    return new Promise<void>(async (resolve,reject)=>{
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/viewedUserNotifications", { uid:userAuthService.currentUserComplete.user.authUid,idToken }).subscribe(
          (response:any) => {
              console.log(response);
              resolve();
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
            console.log("failed response", failedResponse);
            reject();
        }
      )
    })
  }

}
